import { PageCriteria } from 'src/app/_models/page-criteria';

export class AccountCriteria extends PageCriteria{
}

export const AccountCriteriaGroup = {
    group: "BillType"
}